import React from "react";
import { hero } from "../data";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__bg" />
      <div className="hero__content">
        <span className="hero__kicker">{hero.kicker}</span>
        <h1 className="hero__title">
          {hero.title[0]}
          <br />
          <span>{hero.title[1]}</span>
        </h1>
        <p className="hero__sub">{hero.subtitle}</p>
        <div className="hero__actions">
          <a href="#contact" className="btn btn--primary">Solicită o ofertă</a>
          <a href="#avantaje" className="btn btn--ghost">De ce leasing operațional</a>
        </div>
        <ul className="hero__badges">
          {hero.badges.map((b, i) => (
            <li key={i} style={{ "--d": `${0.32 + i * 0.08}s` }}>
              <strong>{b.strong}</strong>
              <span>{b.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
